module.exports = __webpack_public_path__ + "static/media/loader.daefb142.gif";